<div class="gw-space-y-6 gw-p-x-large gw-max-w-3xl">
  <form [formGroup]="formGroup" (ngSubmit)="onSubmit()">
    <p class="gw-text-text-primary gw-text-base gw-mb-2">
      {{
        'features.settings.parameters.defaultRecipientSettings.description'
          | translate
      }}
    </p>
    <p class="gw-text-text-secondary gw-text-sm gw-mb-4">
      {{
        'features.settings.parameters.defaultRecipientSettings.hint' | translate
      }}
    </p>
    <textarea
      formControlName="json"
      rows="16"
      class="gw-w-full gw-font-mono gw-text-sm gw-p-3 gw-rounded-md gw-border gw-border-border-normal gw-bg-background-elevation-1"
      spellcheck="false"
    ></textarea>
    <div class="gw-flex gw-justify-end gw-gap-3 gw-mt-6">
      <gatewee-button
        variant="outline"
        [title]="'common.actions.cancel' | translate"
        (clicked)="close()"
        [disabled]="submitting"
      ></gatewee-button>
      <gatewee-button
        variant="primary"
        [title]="'common.actions.save' | translate"
        type="submit"
        [disabled]="submitting || formGroup.invalid"
      ></gatewee-button>
    </div>
  </form>
</div>
